// extracted by mini-css-extract-plugin
module.exports = {"resultsNumber":"results-module--resultsNumber--2FUdw"};